var ONE_MB_IN_BYTES = 1024 * 1024;
export var FILE_ATTACHMENT_TYPE = 'FileAttachment:#Exchange';
export var ITEM_ATTACHMENT_TYPE = 'ItemAttachment:#Exchange';
export var ITEM_ID_ATTACHMENT_TYPE = 'ItemIdAttachment:#Exchange';
export var REFERENCE_ATTACHMENT_TYPE = 'ReferenceAttachment:#Exchange';
export var BOX = 'Box';
export var DROPBOX = 'Dropbox';
export var FACEBOOK = 'Facebook';
export var GDRIVE = 'GDrive';
export var MAILBOX = 'Mailbox';
export var MAIL_MESSAGE = 'MailMessage';
export var ONE_DRIVE_CONSUMER = 'OneDriveConsumer';
export var ONE_DRIVE_PRO = 'OneDrivePro';
export var RECENT_ATTACHMENTS = 'RecentAttachments';
export var WOPI = 'Wopi';
export var WOPI_BOX = 'WopiBox';
export var WOPI_DROPBOX = 'WopiDropbox';
export var WOPI_EGNYTE = 'WopiEgnyte';
export var MAX_SIZE_FOR_GENERATING_THUMBNAIL_IN_BYTES = 10 * ONE_MB_IN_BYTES;
export var AttachmentConstants = {
    providers: {
        BOX: BOX,
        DROPBOX: DROPBOX,
        FACEBOOK: FACEBOOK,
        GDRIVE: GDRIVE,
        MAILBOX: MAILBOX,
        ONE_DRIVE_CONSUMER: ONE_DRIVE_CONSUMER,
        ONE_DRIVE_PRO: ONE_DRIVE_PRO,
        RECENT_ATTACHMENTS: RECENT_ATTACHMENTS,
        WOPI: WOPI,
        WOPI_BOX: WOPI_BOX,
        WOPI_EGNYTE: WOPI_EGNYTE,
    },
    attachmentTypes: {
        FILE_ATTACHMENT_TYPE: FILE_ATTACHMENT_TYPE,
        ITEM_ATTACHMENT_TYPE: ITEM_ATTACHMENT_TYPE,
        ITEM_ID_ATTACHMENT_TYPE: ITEM_ID_ATTACHMENT_TYPE,
        REFERENCE_ATTACHMENT_TYPE: REFERENCE_ATTACHMENT_TYPE,
    },
};
//# sourceMappingURL=attachmentConstants.js.map